import React from 'react'
import { guideList1, guideList2 } from '../../data';
import { ThemeContext } from './../../theme/DarkMode';
import { useTranslation } from 'react-i18next';

export const DropDownGuideItems = () => {
  const { theme } = React.useContext(ThemeContext);
  const { i18n } = useTranslation();
  const [value, setValue] = React.useState('');
  const isRTL = i18n.language.toLowerCase() === 'fa';

  const handleSelect = (e) => {
    setValue(e.target.value)
    window.location.href = value;
  }

  const getTitle = (item) => {
    const lang = i18n.language.toLowerCase();
    return item.title[lang] || item.title.en;
  }

  return (
    <div className='select-container'>
      <select 
        className={theme === 'light' ? 'light-select' : 'select'} 
        defaultValue="top" 
        value={value} 
        onChange={handleSelect}
        style={{ direction: isRTL ? 'rtl' : 'ltr' }}
      >
        <option className={theme === 'light' ? 'light-title' : 'title'}>
          {isRTL ? 'تعاریف' : 'Definitions'}
        </option>
        {guideList1.map(item => (
          <option key={item.id} value={item.href}>
            {getTitle(item)}
          </option>
        ))}
        <option className={theme === 'light' ? 'light-title' : 'title'}>
          {isRTL ? 'امکانات' : 'Features'}
        </option>
        {guideList2.map(item => (
          <option key={item.id} value={item.href}>
            {getTitle(item)}
          </option>
        ))}
      </select>
    </div>
  )
}
